const apps = [
    /**
     * name: 微应用名称 - 具有唯一性，子应用中  package.json 中的name  唯一值
     * entry: 微应用入口 - 通过该地址加载微应用
     * container: 微应用挂载节点 - 微应用加载完成后将挂载在该节点上
     * activeRule: 微应用触发的路由规则 - 触发路由规则后将加载该微应用
     */
    {
        name: "AS-Editor",
        entry: "http://192.168.124.13:8080/template/",
        container: "#container",
        activeRule: "/template"
    },
    {
        name: "traceH5Template",
        entry: "http://192.168.124.13:8081/traceH5Template/",
        container: "#container",
        activeRule: "/traceH5Template"
    },
   
];
export default apps;